import { render, staticRenderFns } from "./form-section-label.vue?vue&type=template&id=a4229840&scoped=true"
import script from "./form-section-label.vue?vue&type=script&lang=js"
export * from "./form-section-label.vue?vue&type=script&lang=js"
import style0 from "./form-section-label.vue?vue&type=style&index=0&id=a4229840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4229840",
  null
  
)

export default component.exports